import { Col, Form, Input, Row } from 'antd';
import Text from 'antd/lib/typography/Text';
import Title from 'antd/lib/typography/Title';
import { LanguageContext } from 'contexts/LanguageContext';
import React, { useContext } from 'react';

interface CampaignNameProps {
	name: string;
	value: string;
	onChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
	required?: boolean;
	message?: string;
}

export default function (props: CampaignNameProps) {
	const { value, onChange } = props;
	const validateStatus = props.message ? 'error' : undefined;
	const { dictionary } = useContext(LanguageContext);

	return (
		<>
			<Row style={{ height: 50, paddingTop: '2em' }}>
				<Title level={2}>
					<Text type="gray-9">{`${dictionary.set_campaign_name}:`}</Text>
				</Title>
			</Row>
			<Row style={{ height: 200, display: 'flex', alignItems: 'center' }}>
				<Form.Item
					validateStatus={validateStatus}
					help={props.message}
					required={props.required}
					style={{
						width: '100%',
						marginTop: '24px',
						textAlign: 'left',
					}}
				>
					<Input
						name={props.name}
						size="large"
						placeholder={dictionary.campaign_name_placeholder}
						autoFocus
						value={value}
						onChange={onChange}
					/>
				</Form.Item>
			</Row>
			<Row style={{ height: 50 }}></Row>
		</>
	);
}
